var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2786",
    "data-name": "Group 2786",
    transform: "translate(-131 -556)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1296",
    "data-name": "Rectangle 1296",
    width: 24,
    height: 24,
    transform: "translate(131 556)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-2031.27-16v-2.7l8.329-8.329,2.642,2.75L-2028.573-16Zm9.667-12.584,1.423-1.425s.266-.6,1.23.371,1.7,1.716,1.7,1.716.365.489,0,.789-1.393,1.293-1.393,1.293Z",
    transform: "translate(2167.177 591.095)",
    fill: "#15355c"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/Editicon.d89a11db75cd98c6f35b32c980c1c8f5.svg";
export { ForwardRef as ReactComponent };